module.exports = __webpack_public_path__ + "media/images/posts/wedding-guests-ab2469b454ec9a177dbe569e6c0df99f.jpg";